export const extractAuditLogNote = (details: unknown): string | undefined => {
  if (!details) {
    return undefined
  }

  if (typeof details === 'string') {
    try {
      const parsed = JSON.parse(details)
      if (parsed) {
        if (typeof parsed.audit_log === 'string') {
          return parsed.audit_log
        }
        if (typeof parsed.auditLog === 'string') {
          return parsed.auditLog
        }
      }
    } catch {
      return undefined
    }
    return undefined
  }

  if (typeof details === 'object' && details !== null) {
    if ('audit_log' in details) {
      const value = (details as { audit_log?: unknown }).audit_log
      return typeof value === 'string' ? value : undefined
    }
    if ('auditLog' in details) {
      const value = (details as { auditLog?: unknown }).auditLog
      return typeof value === 'string' ? value : undefined
    }
  }

  return undefined
}

export const extractNotesToPublic = (details: unknown): string | undefined => {
  if (!details) {
    return undefined
  }

  if (typeof details === 'string') {
    try {
      const parsed = JSON.parse(details)
      if (parsed) {
        if (typeof parsed.notes_to_public === 'string') {
          return parsed.notes_to_public
        }
        if (typeof parsed.notesToPublic === 'string') {
          return parsed.notesToPublic
        }
      }
    } catch {
      return undefined
    }
    return undefined
  }

  if (typeof details === 'object' && details !== null) {
    if ('notes_to_public' in details) {
      const value = (details as { notes_to_public?: unknown }).notes_to_public
      return typeof value === 'string' ? value : undefined
    }
    if ('notesToPublic' in details) {
      const value = (details as { notesToPublic?: unknown }).notesToPublic
      return typeof value === 'string' ? value : undefined
    }
  }

  return undefined
}

export const normalizeNoteValue = (value?: string | null): string | null => {
  if (typeof value !== 'string') {
    return null
  }
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : null
}
